import React, { useContext, useEffect, useCallback, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import PropTypes from 'prop-types';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import CommunityHeartIcon from '../../../Icons/CommunityHeartIcon/CommunityHeartIcon';
import MiniCommunityHeartIcon from '../../../Icons/MiniCommunityHeartIcon/MiniCommunityHeartIcon';
import './CommunityLikeButton.scss';

const CommunityLikeButton = ({ hash, showLabel }) => {
    // CONSTS ==========================
    const { isLoggedIn, wrapAuth } = useContext(PageContext);
    const { getContent, vote } = useContext(CommunityContext);
    const content = getContent(hash);
    const [isActive, setIsActive] = useState(false);
    const contentIsComment = content?.type === 'community-comment';
    const emptyClass = content.likes === 0 ? 'empty-styling' : '';
    const authMetrics = {
        login_trigger: 'community-like',
        community_content_key: `${content.type}-${content.hash}`,
        community_on_comment: content.type === 'community-comment',
    };

    // FUNCTIONS ======================================
    useEffect(() => {
        setIsActive(content?.userLiked);
    }, [setIsActive, content?.userLiked]);

    const handleClick = useCallback(() => {
        if (!isLoggedIn()) return;
        vote(content.hash, 'like');
        setIsActive(!isActive);
    }, [isLoggedIn, vote, isActive, setIsActive, content.hash]);

    // RENDER ======================================
    return wrapAuth(
        `community-like-${content.hash}`,
        <>
            <button
                type="button"
                className={`component-Community-ReactionBar-CommunityLikeButton ${emptyClass}`}
                onClick={handleClick}
            >
                {contentIsComment ? (
                    <MiniCommunityHeartIcon isActive={isActive} />
                ) : (
                    <CommunityHeartIcon isActive={isActive} />
                )}
                {showLabel && content.likes <= 1 && (
                    <p className="button-label">
                        {content.likes !== 0 ? `${content.likes} like` : 'Like'}
                    </p>
                )}
                {showLabel && content.likes > 1 && (
                    <p className="button-label">{content.likes} likes</p>
                )}
            </button>
        </>,
        authMetrics
    );
};

CommunityLikeButton.propTypes = {
    hash: PropTypes.string.isRequired,
    showLabel: PropTypes.bool,
};

CommunityLikeButton.defaultProps = {
    showLabel: false,
};

CommunityLikeButton.displayName = 'CommunityLikeButton';

export default React.memo(CommunityLikeButton);
